export const SIERRA_HANDOFF_COOKIE_NAME = 'sierraHandoffVariables' as const;

const HELP_CENTER_BASE = 'https://help.shipstation.com/hc';
const DEFAULT_LOCALE_PATH = 'en-us';

const LOCALE_PATH_BY_LANGUAGE: Record<string, string> = {
  de: 'de',
  fr: 'fr',
  es: 'es-us',
};

const COUNTRY_TO_HELP_CENTER_URL: Record<string, string> = {
  GB: `${HELP_CENTER_BASE}/en-gb`,
  CA: `${HELP_CENTER_BASE}/en-ca`,
  AU: `${HELP_CENTER_BASE}/en-au`,
  NZ: `${HELP_CENTER_BASE}/en-au`,
  FR: `${HELP_CENTER_BASE}/fr-fr`,
  DE: `${HELP_CENTER_BASE}/de`,
};

export const getHelpCenterUrl = (supportCountry = 'US', params?: Record<string, string>): string => {
  const base = COUNTRY_TO_HELP_CENTER_URL[supportCountry] ?? `${HELP_CENTER_BASE}/${DEFAULT_LOCALE_PATH}`;
  return params ? `${base}?${new URLSearchParams(params).toString()}` : base;
};

export const getHelpCenterUrlByLocale = (locale: string | null | undefined): string => {
  const language = (locale ?? '').split('-')[0].toLowerCase();
  const localePath = LOCALE_PATH_BY_LANGUAGE[language] ?? DEFAULT_LOCALE_PATH;
  return `${HELP_CENTER_BASE}/${localePath}`;
};

export const getHelpCenterArticleUrlByLocale = (locale: string | null | undefined, articleId: string): string =>
  `${getHelpCenterUrlByLocale(locale)}/articles/${articleId}`;

export const getSignInRedirectUrl = (redirectTo: string): string => `support/signin?redirectTo=${encodeURIComponent(redirectTo)}`;

export const getMainSupportUrl = (sellerHomeCountry: string | null): string =>
  getSignInRedirectUrl(getHelpCenterUrl(sellerHomeCountry ?? 'US'));

export const getSupportCasesUrl = (): string => getSignInRedirectUrl(`${HELP_CENTER_BASE}/${DEFAULT_LOCALE_PATH}/requests`);
